import React, { useState } from "react";
import AddButton from "../../../../partials/Buttons/AddButton";
import CancelButton from "../../../../partials/Buttons/CancelButton";
import { UPDATE_REFERRAL } from "../../../../queries/patient.query";
import { useMutation } from "react-apollo";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";
import LoadingSpinner from "../../../../partials/loading";
import { sendNotification } from "../../../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../../../event/model";
import { EventEmitter } from "../../../../event/EventEmitter";

const PatientReferral = ({ id, referral, isAdmin }) => {
    const [_referral, setReferral] = useState(referral);
    const [update, setUpdate] = useState(false);
    const [email, setEmail] = useState();
    const [mobile, setMobile] = useState();
    const [name, setName] = useState();

    const [updateReferralFunc, { loading }] = useMutation(UPDATE_REFERRAL, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.UpdatePatientReferral) {
                const { message, doc } = d.UpdatePatientReferral;
                toast.success(message);
                // const _new = Array.from(_referral);
                // _new.unshift({ name, email, mobile });
                // setReferral(_new);
                sendNotification(doc, ACTION_TYPE.UPDATE, EVENT_TARGET.PATIENT);
                // clear
                setEmail("");
                setMobile("");
                setName("");

                // hide the form
                setUpdate(false);
            }
        },
    });
    EventEmitter.subscribe(EVENT_TARGET.Referral, (event) => setReferral(event));

    return (
        <div className="card">
            <div className="card-head">
                <header>Patient Referral</header>
            </div>
            <div className="card-body min-card">
                <LoadingSpinner loading={loading} bar={true} />
                <div>
                    {!update && (
                        <div className="fade-in">
                            <table className="table table-bordered">
                                <tbody>
                                    {_referral.map((i, idx) => (
                                        <React.Fragment key={idx}>
                                            <tr>
                                                <th>SN</th>
                                                <th>{idx + 1}</th>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <strong>Name</strong>
                                                </td>
                                                <td>{i.name}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <strong>Email</strong>
                                                </td>
                                                <td>{i.email}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <strong>Phone Number</strong>
                                                </td>
                                                <td>{i.mobile}</td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                    {_referral.length < 1 && (
                                        <tr className="fade-in">
                                            <td rowSpan="2">
                                                <center>
                                                    <p>No Referral Yet!</p>
                                                </center>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <br />
                            {referral.length < 4 && isAdmin && (
                                <center>
                                    <h3>Add New Referral</h3>
                                    <AddButton title={`Add Referral No ${referral.length + 1}`} onClick={() => setUpdate(true)} />
                                </center>
                            )}
                        </div>
                    )}

                    {update && (
                        <div className="fade-in">
                            <form
                                onSubmit={async (evt) => {
                                    evt.preventDefault();

                                    await updateReferralFunc({
                                        variables: { id, model: { name, mobile, email } },
                                    });
                                }}
                            >
                                <div className="form-group">
                                    <label className="control-label" htmlFor="next_name">
                                        Name
                                        <span className="required"> * </span>
                                    </label>
                                    <input
                                        type="text"
                                        onChange={({ target }) => setName(target.value)}
                                        name="next_name"
                                        id="next_name"
                                        required
                                        placeholder="enter full name"
                                        className="form-control input-height"
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="control-label" htmlFor="next_name">
                                        Email
                                        <span className="required"> * </span>
                                    </label>
                                    <input
                                        type="email"
                                        onChange={({ target }) => setEmail(target.value)}
                                        name="next_email"
                                        id="next_name"
                                        required
                                        placeholder="enter email address"
                                        className="form-control input-height"
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="control-label" htmlFor="next_name">
                                        Phone NUmber
                                        <span className="required"> * </span>
                                    </label>
                                    <input
                                        type="text"
                                        onChange={({ target }) => setMobile(target.value)}
                                        name="phone_ref"
                                        id="phone_ref"
                                        required
                                        placeholder="enter phone number"
                                        className="form-control input-height"
                                    />
                                </div>
                                <div className="text-right mt-5 mb-3">
                                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-10 btn-circle btn-success">
                                        Submit
                                        <i className="material-icons">keyboard_arrow_down</i>
                                    </button>
                                    <CancelButton
                                        onClick={() => {
                                            setUpdate(false);
                                        }}
                                    />
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
            <div className="card-footer m-4"></div>
        </div>
    );
};

export default PatientReferral;
